import { Flex, Text } from '@chakra-ui/react';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText } from '@morressier/alembic';
import { journalPublishingModels } from '@publishing-engine/domain/models';
import { IGetTransferOfferResponse } from '@publishing-engine/submission-service/src/endpoints/api.response-types';

export const TransferTargetJournalInfo = ({
  journal
}: {
  journal: IGetTransferOfferResponse['targetJournals'][number];
}) => {
  return (
    <Flex key={journal.id} flexDirection={'column'} gap={2}>
      <Flex flexDirection="column">
        <Text textStyle="headingItem">{journal.name}</Text>
        <Text>
          {journal.articleTypeName} •{' '}
          {journalPublishingModels[journal.publishingModel]} Journal
        </Text>
      </Flex>
      <ButtonText
        iconLeft={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
        marginLeft={-1}
        alignSelf="start"
        onClick={() => window.open(journal.url)}
        isDisabled={!journal.url}
      >
        About This Journal
      </ButtonText>
    </Flex>
  );
};
